(() => {
  if (window.ggPdpReelupInitialized) return;
  window.ggPdpReelupInitialized = true;

  // ReelUp renders its player in a portal outside the PDP section. Scope the
  // video-only view to the widget that opened it, not every ReelUp on the site.
  const videoOnlyClass = 'gg-pdp-reelup-video-only';
  document.addEventListener('click', (event) => {
    const card = event.target.closest?.('.reelUp_card_body');
    if (!card) return;
    document.documentElement.classList.toggle(videoOnlyClass, !!card.closest('.gg-pdp-main__reelup'));
  }, true);
  new MutationObserver((records) => {
    if (records.some((record) => record.oldValue?.split(/\s+/).includes('reelup_modal_active'))
      && !document.documentElement.classList.contains('reelup_modal_active')) {
      document.documentElement.classList.remove(videoOnlyClass);
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });

  const initialize = (scope) => {
    scope.querySelectorAll('.gg-pdp-main__reelup').forEach((wrapper) => {
      if (wrapper.ggReelupObserver) return;
      const controller = new AbortController();
      wrapper.ggReelupController = controller;
      // Only stop the small previews inside this wrapper. ReelUp's popup is
      // rendered outside it and keeps its own playback and controls.
      const stopPreview = (event) => {
        if (event.target instanceof HTMLVideoElement) event.target.pause();
      };
      wrapper.addEventListener('play', stopPreview, { capture: true, signal: controller.signal });
      wrapper.addEventListener('playing', stopPreview, { capture: true, signal: controller.signal });
      const enhanceCards = () => {
        wrapper.querySelectorAll('.reelUp_card_body').forEach((card, index) => {
          const video = card.querySelector('video');
          if (video) {
            if (video.autoplay) video.autoplay = false;
            if (!video.paused) video.pause();
            if (video.preload !== 'none') video.preload = 'none';
          }
          const poster = card.querySelector('meta[itemprop="thumbnailUrl"]')?.content
            || video?.poster || card.querySelector('.reelUp_thumbnail_wrapper img')?.src;
          if (poster && card.dataset.ggPoster !== poster) {
            card.dataset.ggPoster = poster;
            card.style.setProperty('--gg-reelup-poster', `url(${JSON.stringify(poster)})`);
          }
          if (card.hasAttribute('data-gg-accessible')) return;
          card.setAttribute('data-gg-accessible', '');
          card.setAttribute('role', 'button');
          card.setAttribute('tabindex', '0');
          card.setAttribute('aria-label', `Productvideo ${index + 1} afspelen`);
          card.addEventListener('keydown', (event) => {
            if (event.target === card && (event.key === 'Enter' || event.key === ' ')) {
              event.preventDefault();
              card.click();
            }
          });
        });
      };
      enhanceCards();
      wrapper.ggReelupObserver = new MutationObserver(enhanceCards);
      wrapper.ggReelupObserver.observe(wrapper, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['autoplay', 'poster', 'src', 'content']
      });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    if (event.target.querySelector('.gg-pdp-main__reelup') && window.REELUP?.executeApp) {
      window.REELUP.executeApp();
    }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.gg-pdp-main__reelup').forEach((wrapper) => {
      wrapper.ggReelupObserver?.disconnect();
      wrapper.ggReelupController?.abort();
      delete wrapper.ggReelupObserver;
    });
  });
})();
